import { PaymentDeferralCancellationReason as GqlPaymentDeferralCancellationReason } from '@willow/graphql-iso/src/app';
import { assertNever, PaymentDeferralCancellationReason } from '@willow/types-iso';

export const getPaymentDeferralCancellationReasonLabel = (
  reason: PaymentDeferralCancellationReason | GqlPaymentDeferralCancellationReason,
): string => {
  switch (reason) {
    case 'noAgreement':
    case GqlPaymentDeferralCancellationReason.NoAgreement:
      return 'Plan not agreed to';
    case 'reviewingDifferentPlan':
    case GqlPaymentDeferralCancellationReason.ReviewingDifferentPlan:
      return 'Reviewing for a different plan';
    case 'other':
    case GqlPaymentDeferralCancellationReason.Other:
      return 'Other';
    default:
      assertNever(reason);
  }
};
